import { Offerte, SchedaConfrontabilitaEle, SchedaConfrontabilitaGas, DettaglioSchedaConfrontabilitaEle, DettaglioSchedaConfrontabilitaGas } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class IrenTuttoOkLuce {
  public static offerta(): Offerte {
    return {
		Flg_Indicizzato: false,
      Id_Offerta: 127,
      Id_Foritore: 1,
      Id_comodity: 1,
      TipoContratto: 1,
      NomeOfferta: "Iren TUTTOAPOSTO Luce",
      LinkFoto: "./assets/images/offerte-iren/tutto-ok-luce.jpg",
      LinkFotoLarge: "./assets/images/offerte-iren/tutto-ok-luce.jpg",
      LinkFotoMid: "./assets/images/offerte-iren/tutto-ok-luce.jpg",
      LinkFotoSm: "./assets/images/offerte-iren/tutto-ok-luce.jpg",
      LinkFotoCarousel: "./assets/images/offerte-iren/tutto-ok-luce.jpg",
      DescrizioneCarousel: "Che Offerta super! Inclusa la polizza di assistenza casa",
      DescrizioneNomeOfferta: "Usufruisci di 30€ di bonus sulla fornitura elettrica! ",
      PromozioneOfferta: "",
      Sezioni: [
        {
          NomeSezione: "GRATIS POLIZZA ASSICURATIVA CASA",
          DescrizioneSezione: "Polizza di IMA Italia Assistance S.p.A. di assistenza per piccoli guasti della tua abitazione: la polizza ti garantirà un servizio di pronto intervento 24 ore su 24 per 365 giorni all’anno. ",
          lstPunti: []
        },
        {
          NomeSezione: "RISPARMIO ASSICURATO",
          DescrizioneSezione: "Sottoscrivendo questa proposta potrai usufruire di un Bonus pari a 30 € per ogni fornitura, suddiviso in 3 Bonus da 10 € ciascuno, che verranno accreditati al cliente con la seguente modalità:",
          lstPunti: ["il 1° sulla bolletta del 1° mese di fornitura;", " il 2° sulla bolletta del 6° mese di fornitura;", " il 3° sulla bolletta del 12° mese di fornitura.", " Il bonus corrisponde, in termini di risparmio sulla materia a 0,011 €/Kwh  (da 0,083 a 0,072) per il cliente tipo (2.700Kwh di consumo annuo).", "Prezzo fisso e invariabile per due anni!"]

        }
        
      ],
      PrezzoEle: 0.0830,
      PrezzoGas: 0.0,

      TitoloPlus: "Vantaggi assicurati",
      Plus: ["Bonus di 30€", "Prezzo fisso e invariabile per due anni!", " IREN TUTTOAPOSTO Luce ti regala una polizza di IMA Italia Assistance S.p.A. di assistenza per piccoli guasti della tua abitazione: la polizza ti garantirà un servizio di pronto intervento 24 ore su 24 per 365 giorni all’anno. "]


      , schedaconfrontabilitaele: {
        tabellaConfrontabilita: [
          { consumoannuo: 1500, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 324.93 },
          { consumoannuo: 2200, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 433.26 },
          { consumoannuo: 2700, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 519.00 },
          { consumoannuo: 3200, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 604.74 },
          { consumoannuo: 1500, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 324.93 },
          { consumoannuo: 2200, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 433.26 },
          { consumoannuo: 2700, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 519.00 },
          { consumoannuo: 3200, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 604.74 },
          { consumoannuo: 1500, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 324.93 },
          { consumoannuo: 2200, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 433.26 },
          { consumoannuo: 2700, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 519.00 },
          { consumoannuo: 3200, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 604.74 },

          
          { consumoannuo: 900, tipoprofilo: 1, Residente: 2, potenza: 3, importo: 378.346 },
          { consumoannuo: 4000, tipoprofilo: 1, Residente: 2, potenza: 3, importo: 858.13 },
          { consumoannuo: 900, tipoprofilo:2, Residente: 2, potenza: 3, importo: 378.346 },
          { consumoannuo: 4000, tipoprofilo: 2, Residente: 2, potenza: 3, importo: 858.13 },
          { consumoannuo: 900, tipoprofilo: 3, Residente: 2, potenza: 3, importo: 378.346 },
          { consumoannuo: 4000, tipoprofilo: 3, Residente: 2, potenza: 3, importo: 858.13 },

          { consumoannuo: 3500, tipoprofilo: 1, Residente: 1, potenza: 4.5, importo: 633.00 },
          { consumoannuo: 3500, tipoprofilo: 2, Residente: 1, potenza: 4.5, importo: 633.00 },
          { consumoannuo: 3500, tipoprofilo: 3, Residente: 1, potenza: 4.5, importo: 633.00 },

          { consumoannuo: 3500, tipoprofilo: 1, Residente: 2, potenza: 4.5, importo: 633.00 },
          { consumoannuo: 3500, tipoprofilo: 2, Residente: 2, potenza: 4.5, importo: 633.00 },
          { consumoannuo: 3500, tipoprofilo: 3, Residente: 2, potenza: 4.5, importo: 633.00 }

        ]
      }




      , schedaconfrontabilitagas:
      {
        tabellaConfrontabilita: []
      }
      , lstModalitaPagamento: ["1", "2"]
      , scontoRid: 0
      , TipoSoglieEle: Soglie.SogliaMomoEleNew()
      ,ImportoAnnuoLordo: 0
        ,ImportoAnnuoNetto: 0
        ,ImportoMensileLordo: 0
        ,ImportoMensileNetto: 0
        ,iscopertura: "" 
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/archivioofferte/IrenTuttoOkLuce.ts